import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { CenterFrameLayout } from 'Layouts';
import { trackEvent, TRACKING_ENUMS } from 'Utils/Analytics';
import { fetchPayments } from 'State/Payments/PaymentActions';
import { fetchProfileInfo } from 'State/User/UserActions';
import BillingHistoryList from 'Features/BillingHistory/BillingHistoryList';
import ActiveUserPlan from 'Features/MyPlan/ActiveUserPlan';

export function BillingHistoryContainerComponent(props) {
  const {
    payments: { isSuccess, hasPayments, orders, activeBillInfo, nextBillInfo },
    fetchPayments,
    fetchProfileInfo,
    entitlementId,
    routes,
  } = props;

  useEffect(() => {
    fetchProfileInfo();
    trackEvent(TRACKING_ENUMS.EVENT_BILLING_HISTORY_SELECTED);
  }, [fetchProfileInfo]);

  useEffect(() => {
    if (!isSuccess) fetchPayments(entitlementId);
  }, [fetchPayments, entitlementId, isSuccess]);

  return (
    <CenterFrameLayout
      title="My Billing History"
      showLoader={!isSuccess}
      goBack="Back to My Account"
      backUrl={routes.myAccount}
    >
      {(activeBillInfo || nextBillInfo) && (
        <ActiveUserPlan activeBillInfo={activeBillInfo} nextBillInfo={nextBillInfo} />
      )}
      {hasPayments ? (
        <BillingHistoryList orders={orders} routes={routes} />
      ) : (
        <div className="noBilling">Billing history is not available.</div>
      )}
    </CenterFrameLayout>
  );
}

export const BillingHistoryContainer = connect(
  ({
    payments,
    appConfig: {
      routes,
      defaultConfig: { entitlementId },
    },
  }) => ({ routes, payments, entitlementId }),
  { fetchPayments, fetchProfileInfo }
)(React.memo(BillingHistoryContainerComponent));
